export const sortControls = [
  {
    id: 'services-0',
    label: 'All Services',
    category: '',
  },
  {
    id: 'services-1',
    label: 'Bindery',
    category: 'bindery',
  },
  {
    id: 'services-2',
    label: 'Finishing',
    category: 'finishing',
  },
  {
    id: 'services-3',
    label: 'Mailing & Fullfillment',
    category: 'mailing',
  },
];

export const getServiceHeading = (category: string) => {
  switch (category) {
    case 'bindery': {
      return 'Enhance your print materials with expert binding solutions, including saddle stitching, spiral binding, wire-O binding, and perfect binding. We deliver a sleek, professional finish with precision and craftsmanship. Whether for booklets, brochures, or any custom finish, our durable, high-quality results make a lasting impact.';
    }
    case 'finishing': {
      return 'Make your print materials stand out with premium finishing services, including specialty coatings, die-cutting, embossing, foil stamping, and specialty crafted handwork. We enhance every project with expert craftsmanship and attention to detail, ensuring high-quality, polished results that leave a lasting impression.';
    }
    case 'mailing': {
      return 'Ensure your print materials are delivered efficiently and on time with reliable mailing solutions, including data processing, address verification, inkjet printing, tabbing, and presorting. From preparation to distribution, we handle every detail with precision and care, maximizing accuracy and postal savings for your business.';
    }
    default: {
      return 'At R&M Bindery, we provide expert bindery and post-press services to elevate your print projects with precision and craftsmanship. From cutting and folding to stitching and perfect binding, we handle every detail with care. Explore our full range of services or contact us for custom solutions tailored to your needs.';
    }
  }
};

export const defaultServiceMetaDescription =
  "Explore RM Bindery's comprehensive range of custom binding, finishing, mailing, and fulfillment services. We deliver precision and quality solutions for businesses across the United States, with a commitment to meeting tight deadlines and exceeding expectations from our Las Vegas, NV location.";
